/** Dictionnaire EN — embarqué dans le bundle principal (Phase 8C). Aucune traduction modifiée au split. */
import type { Dictionary } from './fr.js';

export const en: Dictionary = {
  home: 'Home',
  messages: 'Messages',
  planning: 'Calendar',
  tasks: 'Tasks',
  photos: 'Photos',
  meals: 'Meals',
  settings: 'Settings',
  foyer_tab: 'Home',
  this_week: 'This week',
  planning_du_au_join: 'to',
  planning_week_label: 'Week',
  planning_prev_week: 'Previous week',
  planning_next_week: 'Next week',
  planning_from_word: 'From',
  planning_hero_title: 'The week',
  messages_hero_accent: 'thread',
  cp_home_hero_title: 'The week',
  cp_home_hero_accent_fallback: 'together',
  cp_home_hero_accent_child: 'with {name}',
  meals_hero_title: 'At the table,',
  meals_hero_accent: 'this week',
  meals_kpi_planned: 'Planned',
  meals_kpi_courses: 'Groceries',
  meals_kpi_to_plan: 'To plan',
  meals_kpi_courses_delta: 'items',
  meals_kpi_to_plan_delta: 'days left',
  photos_hero_title: 'The family',
  photos_hero_accent: 'album',
  photos_hero_dateline: 'Recent memories',
  messages_hero_title: 'The family',
  messages_hero_dateline: 'As a family',
  settings_hero_title: 'Your',
  settings_hero_accent: 'home',
  settings_hero_title_cp: 'Your',
  settings_hero_accent_cp: 'settings',
  cp_home_dateline: 'Shared custody',
  cp_act_hero_title: 'Two',
  cp_act_hero_accent: 'weeks',
  cp_act_dateline: 'Custody calendar',
  cp_lia_hero_title: 'The liaison',
  cp_lia_hero_accent: 'book',
  cp_frais_hero_title: 'This month’s',
  cp_frais_hero_accent: 'expenses',
  cp_frais_dateline: 'Monthly balance',
  cp_bag_hero_title: 'School',
  cp_bag_hero_accent: 'bag',
  cp_bag_dateline: 'Before the transition',
  cp_school_hero_title: 'School',
  cp_school_hero_accent: 'life',
  cp_school_dateline: 'Grades & homework',
  cp_settings_dateline: 'Custody & rules',
  onb_step_label: 'Step',
  sw_update_available: 'A fresh version of Nestor is ready — refresh now?',
  sw_update_reload: 'Reload',
  sw_update_later: 'Later',
  mutations_queued: 'Saved locally — we’ll sync as soon as you’re back online.',
  mutations_synced: 'Everything is up to date.',
  mutations_pending_badge: 'Pending',
  invite_section_title: 'Invite a co-parent',
  invite_section_sub: 'Send an email to share this home.',
  invite_button: 'Invite',
  invite_modal_title: 'Invite to join the home',
  invite_email_label: 'Email address',
  invite_email_placeholder: 'eve@example.com',
  invite_role_label: 'Role',
  invite_role_parent: 'Parent',
  invite_role_teen: 'Teen',
  invite_role_child: 'Child',
  invite_submit: 'Send invitation',
  invite_sent_toast: 'Invitation sent.',
  invite_accept_loading: 'Preparing your invitation…',
  invite_accept_title: 'Join',
  invite_accept_invited_by: 'Invited by',
  invite_accept_role_label: 'Proposed role',
  invite_accept_expires_at: 'Expires on',
  invite_accept_button: 'Accept and join',
  invite_accept_signin_first: 'Sign in to accept.',
  invite_accept_signed_in_as: 'Signed in as',
  invite_accepted_toast: 'Welcome to the home.',
  invite_error_expired: 'This invitation has expired or is unknown.',
  invite_error_already: 'This invitation has already been accepted.',
  invite_error_mismatch: 'This invitation is for a different email.',
  invite_error_offline: 'Service unavailable — please retry when online.',
  account_section: 'My account',
  account_anonymous_title: "You're using Nestor in local mode.",
  account_anonymous_sub: 'Create an account to sync your homes across all your devices.',
  account_btn_login: 'Log in',
  account_btn_register: 'Create account',
  account_btn_logout: 'Log out',
  account_offline: 'Service offline — you can sign in as soon as it comes back.',
  account_signed_in_as: 'Signed in as',
  account_email_label: 'Email address',
  account_password_label: 'Password',
  account_name_label: 'Your first name',
  account_lang_label: 'Preferred language',
  account_password_hint: 'At least 8 characters.',
  account_modal_login: 'Sign in',
  account_modal_register: 'Create your account',
  account_btn_submit_login: 'Sign in',
  account_btn_submit_register: 'Create my account',
  account_err_invalid_email: 'This email doesn’t look valid.',
  account_err_password_too_short: 'Password must be at least 8 characters.',
  account_err_name_required: 'Please tell us a first name to display.',
  account_err_invalid_credentials: 'Incorrect email or password.',
  account_err_email_taken: 'This email is already in use. Try signing in instead.',
  account_err_network: 'Cannot reach Nestor. Please try again in a moment.',
  account_err_generic: 'Something went wrong. Please try again in a moment.',
  home_planning_merged: 'Merged planning',
  home_meals_planned: 'Planned meals',
  home_entry_one: 'entry',
  home_entry_other: 'entries',
  home_view_all: 'view all',
  home_kpi_today: 'Today',
  home_kpi_meals: 'Meals',
  home_kpi_photos: 'Photos',
  home_kpi_meals_delta: 'planned',
  home_kpi_photos_delta: 'this week',
  home_family: 'family',
  home_section_today_sub: 'Merged planning',
  home_section_members_sub: "Everyone's day",
  home_section_week_sub: 'Planned meals',
  home_box_family_event: 'Family event',
  home_box_meals_today: "Today's meals",
  home_box_last_messages: 'Latest messages',
  home_no_family_event: 'Nothing scheduled',
  home_meal_lunch: 'Lunch',
  home_meal_dinner: 'Dinner',
  home_meals_to_plan: 'To plan',
  home_no_messages: 'No messages yet',
  home_no_members_hint: 'Add members in Settings to see their day here.',
  weather_enable: 'Enable weather',
  weather_denied: 'Try the weather again?',
  weather_loading: 'Weather…',
  weather_refresh: 'Refresh',
  weather_cond_clear: 'Sunny',
  weather_cond_partly: 'Partly cloudy',
  weather_cond_cloudy: 'Cloudy',
  weather_cond_fog: 'Fog',
  weather_cond_drizzle: 'Drizzle',
  weather_cond_rain: 'Rain',
  weather_cond_snow: 'Snow',
  weather_cond_thunder: 'Thunderstorm',
  tag_event_label: 'Event',
  tag_task_label: 'Task',
  tag_meal_label: 'Meal',
  hello: 'Hello',
  today: 'Today',
  pending: 'remaining',
  done: 'Done',
  save: 'Save',
  recipes: 'Recipes',
  search: 'Search…',
  family: 'Family',
  members: 'Members',
  modal_add_home_title: 'New home',
  modal_add_member_title: 'New member',
  role_help_label: 'About access levels',
  version: 'Version',
  weather: 'Weather',
  access: 'Access levels',
  account: 'My account',
  preferences: 'Preferences',
  grocery: 'Shopping list',
  servings: 'Servings',
  week: 'This week',
  new_meal: 'New meal',
  history: 'History',
  add: 'Add',
  view: 'View',
  hide: 'Hide',
  logout: 'Sign out',
  invite: '+ Invite a member',
  send: 'Send',
  record: 'Record',
  login: 'Sign in',
  notifs: 'Push notifications',
  pw_change: 'Change password',
  family_name: 'Family name',
  from_recipes: 'From recipes',
  manual: 'Added manually',
  connected: 'Connected ✓',
  connect: 'Connect',
  lang_setting: 'Language',
  lang_change: 'Change language',
  cp_home: 'Home',
  cp_journal: 'Journal',
  cp_activities: 'Activities',
  cp_school: 'School',
  cp_bag: 'Bag',
  cp_liaison: 'Liaison',
  cp_frais: 'Expenses',
  cp_settings: 'Settings',
  add_home: '+ Add a home',
  messages_local_hint: 'Messages stay on this device — create an account to sync.',
  messages_sender_label: 'Who is writing?',
  home_type_label: 'Home type',
  home_type_classic: 'Classic',
  home_type_coparenting: 'Co-parenting',
  my_homes: 'My homes',
  active: 'Active',
  switch_home: 'Switch home',
  journal_info: 'Journal — factual log, no chat.',
  custody: 'Custody',
  parent_a: 'Parent A',
  parent_b: 'Parent B',
  bag_complete: 'Bag complete',
  item_ok: 'Present',
  item_missing: 'Missing',
  transfer: 'Transferred',
  ai_suggests: 'Nestor suggests',
  handover: 'Handover',
  score_great: 'Everything is well organized',
  score_ok: 'Good overall organization',
  score_low: 'A few things to prepare',
  weekly_at: 'Week with',
  today_with: 'With',
  work_email: 'Work email',
  sync_cal_btn: 'Sync calendars',
  legal: 'Legal information',
  privacy: 'Privacy policy',
  terms: 'Terms of use',
  rules: 'Program rules',
  lunch: 'Lunch',
  dinner: 'Dinner',
  attach_file: 'Attach file',
  planning_merged: 'Planning',
  role_parent: 'Parent',
  role_teen: 'Teen',
  role_child: 'Child',
  role_parent_desc: 'Full access — create, edit, delete',
  role_teen_desc: 'Add content',
  role_child_desc: 'Read only — check own tasks',
  role_hint_icon_label: 'See access level',
  member_affect_legend: 'Assign to',
  affect_principal: 'Main',
  affect_coparental: 'Co-parenting',
  affect_both: 'Both',
  member_pending: 'Invitation sent',
  member_remove: 'Remove',
  member_remove_title: 'Remove this member',
  member_last_parent_hint:
    'A home always keeps at least one parent — add another parent before removing this one.',
  member_edit: 'Edit',
  data_export: 'Export data',
  account_delete: 'Delete account',
  lang_apply_info: 'Language applies to the entire app.',
  home_rename: 'Rename home',
  home_remove: 'Delete home',
  remove: 'Delete',
  rename: 'Rename',
  coming_soon: 'Coming soon',
  upcoming: 'Upcoming',
  nothing_planned: 'Nothing planned',
  tonight: 'Tonight',
  add_photo: 'Add a photo',
  no_homes_yet: 'No home configured yet.',
  go_to_settings: 'Go to Settings',
  add_event: '+ Event',
  add_task: '+ Task',
  add_task_full: '+ Add a task',
  to_do: 'To do',
  no_pending_tasks: 'No pending tasks!',
  event_title: 'Title',
  event_date: 'Date',
  event_time: 'Time',
  event_location: 'Location',
  task_text: 'Task',
  task_due: 'Due',
  who: 'Who',
  cancel: 'Cancel',
  confirm: 'Confirm',
  close: 'Close',
  unassigned: 'Unassigned',
  weekday_sun: 'S',
  weekday_mon: 'M',
  weekday_tue: 'T',
  weekday_wed: 'W',
  weekday_thu: 'T',
  weekday_fri: 'F',
  weekday_sat: 'S',
  msg_placeholder: 'Message…',
  start_conversation: 'Start the conversation',
  voice_message: 'Voice message',
  mic_denied: 'Microphone not allowed',
  me: 'me',
  voice_recording: 'Recording…',
  stop_recording: 'Stop',
  voice_pause: 'Pause',
  voice_seek: 'Playback position',
  voice_rate: 'Playback speed',
  voice_hold_hint: 'Hold to record',
  voice_slide_cancel: '← Slide to cancel',
  voice_release_cancel: 'Release to cancel',
  attach_image: 'Attach an image',
  no_member_yet: 'Add a member in Settings to start the conversation.',
  from_label: 'From',
  delete_message: 'Delete this message',
  all_photos: 'All photos',
  no_photos: 'No photos yet',
  no_photos_sub: 'Share your first family memories.',
  albums: 'Albums',
  no_albums_sub: 'Albums will appear here when you add photos.',
  auto_album: 'Sort by date',
  auto_album_done: 'Photos sorted into monthly albums.',
  share: 'Share',
  share_album: 'Share this album',
  share_copied: 'Link copied to clipboard.',
  share_unsupported: 'Native sharing is not available on this browser.',
  caption_label: 'Caption',
  album_label: 'Album',
  album_optional: '(optional)',
  no_album: 'No album',
  photo_count_one: 'photo',
  photo_count_other: 'photos',
  plan_meals: '+ Plan meals',
  generate_menu_week: 'Generate weekly menu',
  generation_error: 'Generation error',
  weekly_menu_generated: 'Weekly menu generated!',
  pick_recipe: 'Pick a recipe',
  meal_name_label: 'Meal name',
  tag_label: 'Tag',
  ingredients_label: 'Ingredients',
  service_lunch: 'Lunch',
  service_dinner: 'Dinner',
  meal_empty_dash: '—',
  add_item: 'Add an item…',
  grocery_will_generate: 'The list will generate from your planned meals.',
  grocery_checked_count: 'checked',
  grocery_auto_short: 'auto',
  grocery_share: 'Share the list',
  grocery_manual_one: 'manual',
  grocery_manual_other: 'manual',
  quick_suggestions: 'Quick suggestions',
  breakfast: 'Breakfast',
  snack: 'Snack',
  clear_meal_slot: 'Clear this slot',
  // AI engine — benevolent tone, English mirrors French exactly.
  ai_bag_missing_one: 'Quick reminder: {items} appears missing from the bag',
  ai_bag_missing_many: 'Quick reminder: {items} appear missing from the bag',
  ai_sport_prep: 'Sport activity tomorrow ({activity}) — good time to check the sport bag',
  ai_medical_prep: 'Reminder: {activity} is scheduled for tomorrow. Check the needed documents.',
  ai_recurring_miss: '{item} is often forgotten — worth adding it as a priority?',
  ai_high_stress: 'A few things at once — no worries, the essentials are in place',
  ai_score_excellent: 'Everything looks well organized for the coming days',
  ai_score_good: 'Good overall organization, a few points to check',
  ai_score_low: 'A few things to prepare — it will all work out',
  ai_summary_activities_one: '1 activity planned',
  ai_summary_activities_many: '{count} activities planned',
  ai_summary_journal_one: '1 journal entry',
  ai_summary_journal_many: '{count} journal entries',
  ai_summary_organized: 'Good overall organization',
  ai_summary_to_follow: 'A few points to follow up',
  switch_home_title: 'Switch home',
  switch_home_active: 'Active home',
  switch_home_other: 'Other homes',
  switch_home_none_other: 'No other home — create one in Settings.',
  cp_home_greeting: 'Hello',
  cp_home_with: 'With',
  cp_home_today_activities: 'Today activities',
  cp_home_no_activities: 'No activities today',
  cp_home_recent_journal: 'Recent journal',
  cp_home_no_journal: 'No recent entries',
  cp_home_view_journal: 'View journal →',
  cp_home_bag_title: 'Bag',
  cp_home_bag_missing_one: 'missing',
  cp_home_bag_missing_other: 'missing',
  cp_home_bag_complete: 'Complete',
  cp_home_manage_bag: 'Manage bag →',
  cp_home_ai_suggests: 'Nestor suggests',
  cp_home_no_custody: 'Configure custody in Settings.',
  cp_act_section_title: 'Activities & Custody',
  cp_act_calendar_title: 'Custody calendar',
  cp_act_next_2_weeks: 'Next 2 weeks',
  cp_act_upcoming: 'Upcoming activities',
  cp_act_add_short: '+ Add',
  cp_act_add_long: '+ Add an activity',
  cp_act_none_planned: 'No activities planned',
  cp_act_modal_title: 'New activity',
  cp_act_label_title: 'Title',
  cp_act_placeholder_title: 'Soccer, Doctor…',
  cp_act_label_date: 'Date',
  cp_act_label_time: 'Time',
  cp_act_label_type: 'Type',
  cp_act_label_location: 'Location',
  cp_act_placeholder_location: 'Location…',
  cp_act_label_parent: 'Responsible parent',
  cp_act_type_school: 'School',
  cp_act_type_medical: 'Medical',
  cp_act_type_sport: 'Sport',
  cp_act_type_other: 'Other',
  cp_act_btn_add: 'Add',
  cp_act_remove: 'Remove',
  cp_lia_section_title: 'Liaison notebook',
  cp_lia_intro: 'Official handover notes — timestamped and signable.',
  cp_lia_tab_transmissions: 'Transmissions',
  cp_lia_tab_demandes: 'Requests',
  cp_lia_tab_journal: 'Journal',
  cp_lia_btn_new_transmission: '+ Transmission',
  cp_lia_btn_new_demande: 'Request',
  cp_lia_btn_new_journal: '+ New entry',
  cp_lia_modal_transmission_title: 'New transmission',
  cp_lia_modal_demande_title: 'New request',
  cp_lia_modal_journal_title: 'New journal entry',
  cp_lia_label_text: 'Content',
  cp_lia_placeholder_transmission: 'What needs to be conveyed…',
  cp_lia_placeholder_demande: 'What you want to ask…',
  cp_lia_placeholder_journal: 'Note an important info here…',
  cp_lia_signature_requested: 'Request signature from both parents',
  cp_lia_btn_send: 'Send',
  cp_lia_btn_add: 'Add',
  cp_lia_status_brouillon: 'Draft',
  cp_lia_status_envoye: 'Sent',
  cp_lia_status_signed_a: 'Signed A',
  cp_lia_status_signed_b: 'Signed B',
  cp_lia_status_signed_both: 'Both signed',
  cp_lia_status_pending: 'Pending',
  cp_lia_status_accepted: 'Accepted',
  cp_lia_status_refused: 'Refused',
  cp_lia_sign_a: 'Sign ({parent})',
  cp_lia_sign_b: 'Sign ({parent})',
  cp_lia_accept: '✓ Accept',
  cp_lia_refuse: '✗ Refuse',
  cp_lia_empty_transmissions: 'No transmissions yet. Create one to formalize an info.',
  cp_lia_empty_demandes: 'No requests yet.',
  cp_lia_empty_journal: 'Empty journal. Note here a health, mood or event info.',
  cp_lia_journal_intro: 'The journal is a factual information log — no real-time chat.',
  cp_frais_section_title: 'Shared expenses',
  cp_frais_balance_total: 'Total',
  cp_frais_balanced: 'Balanced',
  cp_frais_owes_template: '{from} owes {amount} to {to}',
  cp_frais_btn_add: '+ Add an expense',
  cp_frais_modal_title: 'New expense',
  cp_frais_label_description: 'Description',
  cp_frais_placeholder_description: 'e.g. pharmacy, supplies…',
  cp_frais_label_amount: 'Amount (€)',
  cp_frais_label_date: 'Date',
  cp_frais_label_category: 'Category',
  cp_frais_label_paidby: 'Paid by',
  cp_frais_cat_sante: 'Health',
  cp_frais_cat_education: 'Education',
  cp_frais_cat_vetements: 'Clothing',
  cp_frais_cat_loisirs: 'Leisure',
  cp_frais_cat_transport: 'Transport',
  cp_frais_cat_autre: 'Other',
  cp_frais_empty: 'No expense recorded',
  cp_frais_remove: 'Remove',
  cp_bag_section_title: 'Virtual backpack',
  cp_bag_status_ok: 'Bag complete ✓',
  cp_bag_status_missing_one: '{count} item missing',
  cp_bag_status_missing_other: '{count} items missing',
  cp_bag_summary_template: '{ok}/{total} items present · At {parent}',
  cp_bag_ai_sport_tomorrow: 'Sport activity tomorrow — remember to check the sport gear!',
  cp_bag_card_missing_title: 'Missing',
  cp_bag_card_present_title: 'Present',
  cp_bag_btn_transfer: 'Transferred',
  cp_bag_btn_add: '+ Add an item',
  cp_bag_empty: 'No items in bag',
  cp_bag_modal_title: 'Add an item',
  cp_bag_label_item: 'Item name',
  cp_bag_placeholder_item: 'Teddy bear, notebook, medication…',
  cp_bag_label_icon: 'Icon',
  cp_bag_label_category: 'Category',
  cp_bag_label_location: 'Current location',
  cp_bag_loc_at: 'At',
  cp_bag_loc_home: 'Home',
  cp_bag_cat_essentiel: 'Essential',
  cp_bag_cat_sport: 'Sport',
  cp_bag_cat_ecole: 'School',
  cp_bag_cat_medical: 'Medical',
  cp_bag_cat_autre: 'Other',
  cp_bag_remove: 'Remove',
  cp_school_section_title: 'School',
  cp_school_btn_add: '+ Add an entry',
  cp_school_empty_title: 'No school data',
  cp_school_empty_sub: 'Add grades, homework and teacher information.',
  cp_school_modal_title: 'New school entry',
  cp_school_label_subject: 'Subject',
  cp_school_placeholder_subject: 'Math, French…',
  cp_school_label_type: 'Type',
  cp_school_label_value: 'Value',
  cp_school_placeholder_value: '15/20',
  cp_school_label_teacher: 'Teacher',
  cp_school_placeholder_teacher: 'Mr. Smith…',
  cp_school_label_comment: 'Comment',
  cp_school_placeholder_comment: 'Remark…',
  cp_school_btn_submit: 'Add',
  cp_school_remove: 'Remove',
  cp_school_type_note: 'Grade',
  cp_school_type_devoir: 'Homework',
  cp_school_type_info: 'Info',
  cp_settings_section_title: 'Co-parenting settings',
  cp_settings_custody_title: 'Custody configuration',
  cp_settings_label_parentA: 'Parent A',
  cp_settings_label_parentB: 'Parent B',
  cp_settings_label_startdate: 'Alternation start',
  cp_settings_label_parity: 'Starting week',
  cp_settings_parity_a: 'At Parent A',
  cp_settings_parity_b: 'At Parent B',
  cp_settings_btn_save: 'Save',
  cp_settings_saved: '✓ Saved',
  cp_settings_view_school: 'View school',
  onb_tagline: "Your family's digital home",
  login_title: 'Welcome back!',
  login_sub: 'Sign in to find your home on this device.',
  login_no_account: 'No home yet? Create an account',
  onb_have_account: 'Already have an account? Sign in',
  onb_step1_title: 'Welcome!',
  onb_step1_sub: 'Create your family space in seconds.',
  onb_label_family: 'Family name',
  onb_placeholder_family: 'e.g. Smith, Johnson…',
  onb_error_family: 'Please enter a name',
  onb_btn_continue: 'Continue →',
  onb_step2_title: 'Your admin account',
  onb_step2_sub: 'As the first Parent, you can invite other family members.',
  onb_label_name: 'Your first name',
  onb_placeholder_name: 'First name…',
  onb_error_name: 'Please enter your first name',
  onb_auth_placeholder: 'Email + password : coming Phase 4 (real auth).',
  onb_btn_create: 'Create my family space',
  onb_btn_back: '← Back',
  onb_offline_local:
    'Space created on this device. You can finish setting up your online account from Settings once you’re connected.',
  gdpr_export_done: 'Export downloaded — your data belongs to you.',
  gdpr_delete_confirm:
    'Delete all Nestor data from this device?\n\nHomes, plans, messages, photos and local voice notes will be permanently erased. (Your server account, if any, is not yet deleted by this action.)',
  gdpr_delete_confirm_auth:
    'Delete your Nestor account AND all data on this device?\n\nYour server account, homes where you are the only member, and all local data will be permanently erased. This action cannot be undone.',
  error_boot_title: 'Oops, something got tangled. Your data is safe.',
  error_boot_reload: 'Reload',
  recipe_search_placeholder: 'Search a recipe (name, ingredient…)',
  recipe_search_hint: 'Search across 8,872 recipes, or pick a suggestion:',
  recipe_db_loading: 'Loading the recipe database…',
  recipe_no_result: 'No recipe found — try another word.',
  recipe_view_sheet: 'View recipe sheet',
  recipe_back: '← Back',
  recipe_use: 'Use this recipe',
  recipe_steps: 'Steps',
  recipe_servings: 'servings',
  nut_calories: 'kcal',
  nut_proteins: 'protein',
  nut_carbs: 'carbs',
  nut_fat: 'fat',
  nut_fiber: 'fiber',
  legal_draft_notice: 'Draft document (alpha version).',
  legal_version_line: 'Alpha version — July 2026',
  legal_terms_s1_title: '1. Purpose',
  legal_terms_s1_body:
    'Nestor is a family organisation app: shared calendar, tasks, messages, photos, meals, plus a co-parenting mode (custody calendar, liaison book, shared expenses, backpack).\n\nThese terms govern the use of Nestor during its alpha phase. By using the app, you accept them.',
  legal_terms_s2_title: '2. Alpha version',
  legal_terms_s2_body:
    'Nestor is under active development. Features may change, be removed or contain defects. The service is provided “as is”, with no guarantee of availability or freedom from errors. Remember to export your data regularly (Settings → Export data).',
  legal_terms_s3_title: '3. Accounts and roles',
  legal_terms_s3_body:
    'Nestor works without an account, in local mode: your data then stays on your device. Creating an account (optional) enables multi-device sync.\n\nA home has three roles: Parent (administers everything), Teen (adds content) and Child (views and checks off their own tasks). Accounts are created and managed by a parent. In co-parenting mode, children have no account.',
  legal_terms_s4_title: '4. Your content',
  legal_terms_s4_body:
    'The content you add (photos, messages, events…) remains yours. If you create an account, you only allow us to host it and deliver it to the members of your home — the strict minimum needed to run the service.',
  legal_terms_s5_title: '5. Acceptable use',
  legal_terms_s5_body:
    'Nestor is meant for family and personal use. You agree not to post unlawful content and not to disrupt the service. In case of clear abuse, access to the service may be suspended.',
  legal_terms_s6_title: '6. Changes and contact',
  legal_terms_s6_body:
    'These terms will evolve with the product (beta, public launch). If they change significantly, a notice will appear in the app. For any question, use the contact channel provided with your alpha invitation.',
  legal_privacy_s1_title: '1. Our approach',
  legal_privacy_s1_body:
    'Nestor is built local-first: by default, your data is stored only on your device. Without an account, nothing leaves your device.\n\nWe sell no data and show no advertising.',
  legal_privacy_s2_title: '2. Data on your device',
  legal_privacy_s2_body:
    'Homes, members, calendars, tasks, messages, photos, meals and preferences are stored locally (localStorage and IndexedDB). The suggestion engine’s memory (recurring oversights) also stays on the device: suggestions are computed locally, with nothing sent to a server.',
  legal_privacy_s3_title: '3. Server account (optional)',
  legal_privacy_s3_body:
    'If you create an account, we process: your email, your display name, your password (hashed with argon2id, never stored in plain text) and the home data you sync.\n\nHosting: servers and database at Fly.io; photos and files at Cloudflare R2; transactional emails (invitations, security) sent via Resend. These providers act as processors under the GDPR.',
  legal_privacy_s4_title: '4. Your rights (GDPR)',
  legal_privacy_s4_body:
    'You have the rights of access, rectification, erasure and portability.\n\nTwo actions are available right now in Settings: “Export data” (a complete JSON file) and “Delete account” (erases all local data from the device). If a server account is signed in, “Delete account” also erases the server account and the homes where you are the only member.',
  legal_privacy_s5_title: '5. Security and retention',
  legal_privacy_s5_body:
    'Exchanges with the server are encrypted (HTTPS) and authentication relies on httpOnly cookies with CSRF protection. Server data is kept as long as your account exists, then deleted. No data is used to train AI models.',
  legal_privacy_s6_title: '6. Controller and contact',
  legal_privacy_s6_body:
    'During the alpha phase, processing is operated by the Nestor team. To exercise your rights or ask a question, use the contact channel provided with your alpha invitation.',
  legal_rules_s1_title: '1. The alpha programme',
  legal_rules_s1_body:
    'The alpha programme lets a small group of families try Nestor before its public release. Participation is free, voluntary and by invitation.',
  legal_rules_s2_title: '2. What you accept',
  legal_rules_s2_body:
    'You are testing a work in progress: bugs, interface changes and service interruptions are part of the experience. Some features (sync, notifications) may be switched on or off without notice.',
  legal_rules_s3_title: '3. Your data during the alpha',
  legal_rules_s3_body:
    'Resets may be needed between versions. We will warn you before any operation affecting server data. Export your data regularly (Settings → Export data): it is your best backup.',
  legal_rules_s4_title: '4. Your feedback',
  legal_rules_s4_body:
    'Your feedback (bugs, ideas, confusing spots) is the whole point of the programme. Share it through the channel agreed at your invitation. Never include sensitive information about your children in a bug report.',
  legal_rules_s5_title: '5. Duration and leaving the programme',
  legal_rules_s5_body:
    'The programme ends when the public beta launches. You can leave at any time: export your data, then delete it from Settings. These rules may be adjusted; the version shown in the app prevails.',
};
